/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportUserResponseItem
 */
export interface ImportUserResponseItem {
    /**
     * 
     * @type {boolean}
     * @memberof ImportUserResponseItem
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportUserResponseItem
     */
    isNew?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportUserResponseItem
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserResponseItem
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserResponseItem
     */
    userId?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportUserResponseItem
     */
    createdAt?: number;
}

export function ImportUserResponseItemFromJSON(json: any): ImportUserResponseItem {
    return ImportUserResponseItemFromJSONTyped(json, false);
}

export function ImportUserResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportUserResponseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSuccess': !exists(json, 'isSuccess') ? undefined : json['isSuccess'],
        'isNew': !exists(json, 'isNew') ? undefined : json['isNew'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
    };
}

export function ImportUserResponseItemToJSON(value?: ImportUserResponseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isSuccess': value.isSuccess,
        'isNew': value.isNew,
        'errorMessage': value.errorMessage,
        'email': value.email,
        'userId': value.userId,
        'createdAt': value.createdAt,
    };
}


